"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _AbstractServiceFacade = _interopRequireDefault(require("../AbstractServiceFacade"));

var _ServiceFacadeException = _interopRequireDefault(require("@ikea-aoa/ikea-shared-utils/lib/exception/ServiceFacadeException"));

var _ServiceFactory = _interopRequireDefault(require("../ServiceFactory"));

var _LocalizationServiceFacade = _interopRequireDefault(require("./LocalizationServiceFacade"));

var _ApiPlatformConstant = _interopRequireDefault(require("../constant/ApiPlatformConstant"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _createForOfIteratorHelper(o, allowArrayLike) { var it; if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = o[Symbol.iterator](); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

var STORE_COOKIES = {
  irw: 'selected_store_num_sv_SE',
  nwp: 'iSt',
  roig: 'nif_selected_store_num'
};
/**
 * This class is used as a simple interface for store services.
 */

var StoreServiceFacade = /*#__PURE__*/function (_AbstractServiceFacad) {
  _inherits(StoreServiceFacade, _AbstractServiceFacad);

  var _super = _createSuper(StoreServiceFacade);

  function StoreServiceFacade() {
    _classCallCheck(this, StoreServiceFacade);

    return _super.apply(this, arguments);
  }

  _createClass(StoreServiceFacade, null, [{
    key: "getStores",

    /**
     * Fetches and returns stores.
     *
     * @throws ServiceFacadeException
     * @returns {Promise} Promise object.
     */
    value: function getStores() {
      var _this = this;

      return this._getCachePromise('stores') || new Promise(function (resolve, reject) {
        _LocalizationServiceFacade.default.getData().then(function (data) {
          var apiPlatform = data.localization.apiPlatform;

          if (apiPlatform === _ApiPlatformConstant.default.nwp || apiPlatform === _ApiPlatformConstant.default.irw) {
            var service = apiPlatform === 'nwp' ? _ServiceFactory.default.getService('nwpstore') : _ServiceFactory.default.getService('irwstore');
            service.getStores(data.apiLocalePath).then(function (stores) {
              _this.setCacheItem('stores', stores);

              resolve(stores);
            }).catch(_this._clearCacheAndReject.bind(_this, reject));
          } else {
            _this._clearCacheAndReject(reject, new _ServiceFacadeException.default('Failed to get stores. Only NWP and IRW are supported as API platform.', _this.constructor.serviceName));
          }
        }).catch(_this._clearCacheAndReject.bind(_this, reject));
      });
    }
    /**
     * Sets the store cookie.
     *
     * @param {string} apiPlatform API platform.
     * @param {string} storeId Store id.
     */

  }, {
    key: "setStoreCookie",
    value: function setStoreCookie(apiPlatform, storeId) {
      if (!STORE_COOKIES[apiPlatform]) {
        throw new _ServiceFacadeException.default('Failed to set store cookie. The api platform "' + apiPlatform + '" is not supported.', this.constructor.serviceName);
      }

      document.cookie = "".concat(STORE_COOKIES[apiPlatform], "=").concat(storeId, ";max-age=3600");
    }
    /**
     * Removes the store cookie.
     *
     * @param {string} apiPlatform API platform.
     */

  }, {
    key: "removeStoreCookie",
    value: function removeStoreCookie(apiPlatform) {
      if (!STORE_COOKIES[apiPlatform]) {
        throw new _ServiceFacadeException.default('Failed to remove store cookie. The api platform "' + apiPlatform + '" is not supported.', this.constructor.serviceName);
      }

      document.cookie = "".concat(STORE_COOKIES[apiPlatform], "=-1;max-age=-3600");
    }
    /**
     * Returns the store cookie.
     *
     * @param {string} apiPlatform API platform.
     * @returns {string|null} Store id.
     */

  }, {
    key: "getStoreCookie",
    value: function getStoreCookie(apiPlatform) {
      if (!STORE_COOKIES[apiPlatform]) {
        throw new _ServiceFacadeException.default('Failed to get store cookie. The api platform "' + apiPlatform + '" is not supported.', this.constructor.serviceName);
      }

      var cookieItems = document.cookie.split(';');

      var _iterator = _createForOfIteratorHelper(cookieItems),
          _step;

      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var cookieItem = _step.value;
          var cookie = cookieItem.trim().split('=');

          if (cookie[0] === STORE_COOKIES[apiPlatform] && cookie.length > 0) {
            return cookie[1];
          }
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }

      return null;
    }
    /**
     * Returns the service name.
     *
     * @override
     * @returns {string} Service name.
     */

  }, {
    key: "serviceName",
    get: function get() {
      return 'StoreServiceFacade';
    }
  }]);

  return StoreServiceFacade;
}(_AbstractServiceFacade.default);

exports.default = StoreServiceFacade;